export type AsyncMutationQueue = {
  run<T>(mutation: () => Promise<T>): Promise<T>;
  hasPending(): boolean;
};

export function createAsyncMutationQueue(): AsyncMutationQueue {
  let tail: Promise<unknown> = Promise.resolve();
  let pending = 0;

  return {
    run<T>(mutation: () => Promise<T>): Promise<T> {
      pending += 1;
      const run = tail.catch(() => undefined).then(mutation);
      tail = run.then(() => undefined, () => undefined);
      return run.finally(() => {
        pending = Math.max(0, pending - 1);
      });
    },
    hasPending(): boolean {
      return pending > 0;
    },
  };
}
